import React, { useState, useEffect } from 'react';
import { HeadingTag, ModuleBase, UmbracoForm } from '@/components';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { selectIsRobot } from '@/store/index';
import { useRouter } from 'next/router';

const FormModule = ({ data }) => {
  const [formDefinition, setFormDefinition] = useState();
  const isRobot = useSelector(selectIsRobot);
  const router = useRouter();

  useEffect(() => {
    async function fetchData() {
      const isPreview = !!router.query.isPreview;
      const dataRes = await fetch(`${!isPreview ? '/api' : ''}/umbraco/forms/api/v1/definitions/${data.formId}`).catch(
        console.error,
      );
      if (dataRes && dataRes.ok) {
        const formData = await dataRes.json();
        setFormDefinition(formData);
      }
    }

    if (!isRobot) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.formId, isRobot]);

  if (isRobot) return;

  const containerClass = !data.footerStyled ? 'container' : 'wrapper';

  return (
    <ModuleBase
      data={{ ...data, anchor: 'Enquire' }}
      className={classNames('color-from-bg font-cera py-12 order-2', formDefinition?.cssClass, {
        'px-4 md:px-6 xl:px-8 xxl:px-10 !py-10 lg:!pt-20': data.footerStyled,
      })}
    >
      <div
        className={classNames({
          'flex flex-col lg:flex-row lg:justify-between container bg-secondary-general/10 p-6 lg:py-10 lg:px-14':
            data.footerStyled,
        })}
      >
        {data.heading && (
          <HeadingTag
            data={{ heading: data.heading, htag: 'p' }}
            className={classNames(
              'heading-title text-center color-from-bg  font-ivy-ora text-title-m not-italic font-normal leading-headingReg -tracking-wide mb-6',
              containerClass,
              {
                'max-w-[575px] !text-left': data.footerStyled,
              },
            )}
          />
        )}

        <UmbracoForm
          className={classNames(containerClass, data.footerStyled ? 'lg:px-0 lg:max-w-[533px]' : 'lg:px-[304px]')}
          successClass="text-center py-10 text-h3 color-from-bg"
          formDefinition={formDefinition}
          backgroundColour={data.backgroundColour}
          footerStyled={data.footerStyled}
        />
      </div>
    </ModuleBase>
  );
};

export default FormModule;
